import { createClient } from "@sanity/client";
import type { ClientConfig } from "@sanity/client";

const config: ClientConfig = {
  projectId: "l60ho9y7", // Replace with your Sanity project ID
  dataset: "production",
  apiVersion: "2024-03-19", // Use today's date or your preferred version
  useCdn: false, // Set to false during development to avoid caching issues
  token: "", // Add your token if needed
  ignoreBrowserTokenWarning: true
} as const;

export const client = createClient(config);
